module.exports = __webpack_public_path__ + "media/components/country-flag/static/ls-65688fe8458be9e3ae21ec064c19e6fa.svg";